import { adminHttpClient } from '../commons/adminHttpClient'

export type AnnualAttestationDetailsResponse = {
  hasConfirmedAnnualAttestation: string
  months: MonthResponse[]
  monthRequiresAttestationDecision?: MonthResponse
}

export type MonthResponse = {
  monthName: string
  attested: boolean
  ineligible: boolean
  requiresAttestationDecision: boolean
  isAttestationDecisionMade: boolean
  isFutureMonth: boolean
  mecData?: MecData
}

type MecData = {
  id: string
  providerName: string
  policyName: string
  providerStartDate: string
  startDate: string
  endDate: string
  attestation: boolean
}

const getAnnualAttestationDetails = (planPeriodId: string): Promise<AnnualAttestationDetailsResponse> => {
  return adminHttpClient.get(`/Benefit/AnnualAttestationDetails/${planPeriodId}`)
}

export default getAnnualAttestationDetails
